import setGrabCursor from './setGrabCursor';
import unsetGrabCursor from './unsetGrabCursor';

export default {
  setGrabCursor,
  unsetGrabCursor,
};



// WEBPACK FOOTER //
// ../src/components/core/grab-cursor/index.js